import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useTheme } from "../Auth/ThemeContext";
import PageWrapper from "../Components/Animations/PageWrapper";
import { useAuth } from "../Auth/AuthContext";
import PublisherSidebar from "./PublisherSidebar";

export default function MainLayout() {
  const { theme } = useTheme();
  const { user } = useAuth();

  return (
    <div className={`${theme} flex h-screen w-full overflow-hidden`}>
      <div className="fixed z-40">
        {user?.role === "Admin" ? <Sidebar /> : <PublisherSidebar />}
      </div>

      <div className="flex flex-col flex-1 ml-[80px] md:ml-[260px] transition-all duration-300 bg-gray-100 dark:bg-gray-900 custom:bg-[#fffbe6] overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-y-auto p-6 scrollbar-hide text-gray-900 dark:text-white custom:text-[#222] w-full">
          <PageWrapper className="w-full">
            <Outlet />
          </PageWrapper>
        </main>
      </div>
    </div>
  );
}